import { styled, useTheme } from '@mui/material';
import { MainMenu } from '#components/MainMenu/MainMenu.tsx';
import { Ancestor } from '#enums/ancestors.ts';
import { tt } from '#i18n/index.ts';
import { SlideoutDrawer } from '../SlideoutDrawer/index.tsx';

const MenuContainer = styled('div')(({ theme }) => ({
  height: '100%',
  padding: theme.spacing(3),
  paddingTop: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
  },
}));

export type MenuDrawerProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
};

export const MenuDrawer = ({ open, setOpen }: MenuDrawerProps) => {
  const theme = useTheme();

  return (
    <SlideoutDrawer
      ancestor={Ancestor.Menu}
      anchor="left"
      containerSx={{ height: '100%' }}
      open={open}
      setOpen={setOpen}
      sx={{
        '.MuiDrawer-paper': {
          [theme.breakpoints.up('sm')]: {
            width: '50%',
          },
          [theme.breakpoints.up('md')]: {
            width: '50%',
          },
          [theme.breakpoints.up('lg')]: {
            width: '25%',
          },
          [theme.breakpoints.up('xl')]: {
            width: '25%',
          },
        },
      }}
      title={tt('pages.discover')}
    >
      <MenuContainer>
        <MainMenu setOpen={setOpen} />
      </MenuContainer>
    </SlideoutDrawer>
  );
};
